<div class="mb-5">
  <div class="transaction-container">
    <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
    <button type="button" class="search-button text-white bg-primary font-size-14" (click)="search()">
      {{ 'search.text' | translate }}
    </button>
  </div>

  <fgb-transaction-list
    *ngIf="selectedValues"
    [startDate]="selectedValues.start"
    [endDate]="selectedValues.end"
    [memberId]="memberId"
    [transactionType]="selectedValues.type"
  ></fgb-transaction-list>
</div>
